import { useState } from 'react';
import { View } from 'react-native';
import ActionSheet from 'react-native-actions-sheet';
import { Text } from '@ui-kitten/components';

import useMealPlanHint from '../../Hooks/useMealPlanHint';
import ThemeStyle from '../../Theme/styles';
import { SECTION_TITLE } from '../../Theme/typographyProps';

import MealPlanTypes from '../MealPlanTypes';

import commonProps from './commonProps';
import modals from './modals';
import styles from './styles';

/**
 * useful data shape is
 * {
 *   value?: 'meal plan type 3_day or 5_day
 * }
 */
function MealPlanTypeSelectorSheet({ sheetId }) {
  const { maybeShowMealPlanFeaturedHint } = useMealPlanHint();
  const [data, setData] = useState();

  const _onTypeSelection = async (type) => {
    await modals.hide(modals.MEAL_PLAN_TYPE_SELECTOR, type);
    maybeShowMealPlanFeaturedHint();
  };

  return (
    <ActionSheet id={sheetId} onBeforeShow={setData} {...commonProps}>
      <View style={styles.contentContainer}>
        <Text style={ThemeStyle.spacingBottom} {...SECTION_TITLE}>
          Select Meal Plan Type
        </Text>

        <View style={ThemeStyle.flexDirectionRowCenterCenter}>
          <MealPlanTypes
            value={data?.value}
            onChange={(data) => _onTypeSelection(data.value)}
          />
        </View>
      </View>
    </ActionSheet>
  );
}

export default MealPlanTypeSelectorSheet;
